import { render, staticRenderFns } from "./PartnersComp.vue?vue&type=template&id=42fb942a&scoped=true"
import script from "./PartnersComp.vue?vue&type=script&lang=js"
export * from "./PartnersComp.vue?vue&type=script&lang=js"
import style0 from "./PartnersComp.vue?vue&type=style&index=0&id=42fb942a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb942a",
  null
  
)

/* custom blocks */
import block0 from "./PartnersComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports